import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Response } from '@models/response-api/ResponseApi';

@Injectable({
	providedIn: 'root',
})
export class ResourceTypeService {
	private url = `${environment.hostAPI}/resourcestypes`;

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<Response>(this.url);
  }
}
